import EventBusService from '../EventBusService';
import EventBusEventName from '../EventBusService/EventBusEventName';
import { EventBus, EventCallback } from '../EventBusService/EventBusService';

export interface RequestDeleteEventDetails {
  context: string;
}

export const createSampleDataDeleteRequester = (getEventBus: () => EventBus) => {
  let unresolvedSampleDataDeletePromise: Promise<boolean> | undefined;

  return (context: string): Promise<boolean> => {
    if (!unresolvedSampleDataDeletePromise) {
      unresolvedSampleDataDeletePromise = new Promise((resolve) => {
        const eventBus = getEventBus();

        const eventHandler: EventCallback<undefined> = (event) => {
          unresolvedSampleDataDeletePromise = undefined;
          resolve(event.type === EventBusEventName.SampleDataDeleted);
          eventBus.removeListener(EventBusEventName.SampleDataDeleted, eventHandler);
          eventBus.removeListener(EventBusEventName.SampleDataDeleteCancelled, eventHandler);
        };

        eventBus.addListener(EventBusEventName.SampleDataDeleted, eventHandler);
        eventBus.addListener(EventBusEventName.SampleDataDeleteCancelled, eventHandler);
        eventBus.dispatch<RequestDeleteEventDetails>(EventBusEventName.SampleDataDeleteRequested, {
          context,
        });
      });
    }

    return unresolvedSampleDataDeletePromise;
  };
};

const requestDeleteSampleData = createSampleDataDeleteRequester(() => EventBusService);

const SampleDataService = {
  requestDeleteSampleData,
};

export default SampleDataService;
